import React, { createContext, useContext, useState, FC, ReactNode, useMemo } from "react";
import { applicationDataFieldTypes, initialApplicationDataFieldValues, applicationData, getInitialApplicationData } from "./applicationDataFieldTypes";

interface ApplicationDataContextType {

    applicationData: applicationData;
    setApplicationData: React.Dispatch<React.SetStateAction<applicationData>>;
    applicationErrors: { [key: string]: string };
    setApplicationErrors: React.Dispatch<React.SetStateAction<{ [key: string]: string }>>;
    checkedTermsAndConditions: boolean;
    setCheckedTermsAndConditions: React.Dispatch<React.SetStateAction<boolean>>;
    viewContext: 'application' | 'confirmSubmit';
    setViewContext: React.Dispatch<React.SetStateAction<'application' | 'confirmSubmit'>>;
}


export const ApplicationDataContext = React.createContext<ApplicationDataContextType | undefined>(undefined);

export const useApplicationData = (): ApplicationDataContextType => {
    const context = useContext(ApplicationDataContext);
    if (!context) throw new Error("useApplicationData must be used within ApplicationDataProvider");
    return context;

}

export const ApplicationDataProvider: FC<{ children: ReactNode }> = ({ children }) => {


    const [applicationData, setApplicationData] = useState<applicationData>(getInitialApplicationData());
    const [applicationErrors, setApplicationErrors] = useState<{ [key: string]: string }>({});
    const [checkedTermsAndConditions, setCheckedTermsAndConditions] = useState<boolean>(false);
    const [viewContext, setViewContext] = useState<'application' | 'confirmSubmit'>('application');

    const contextValue = useMemo(() => ({
        applicationData,
        setApplicationData,
        applicationErrors,
        setApplicationErrors,
        checkedTermsAndConditions,
        setCheckedTermsAndConditions,
        viewContext,
        setViewContext

    }), [applicationData, applicationErrors, checkedTermsAndConditions, viewContext]);

    return (
        <ApplicationDataContext.Provider value={contextValue}>
            {children}
        </ApplicationDataContext.Provider>
    );
}